import {
  codeObject,
  datasourceObject,
  datasourceTypeObject,
  stationObject,
  stnEntity
} from "../../common/constructorObject";

export const evaporationObject = {
  name: "",
  station: {...stationObject},
  stationEntity: {...stnEntity},
  waterTemperatureFilterObject: {
    rowId: 0,
    meteoCode: {...codeObject},
    type: {...datasourceTypeObject},
    datasource: {...datasourceObject}
  },
  windSpeedFilterObject: {
    rowId: 0,
    meteoCode: {...codeObject},
    type: {...datasourceTypeObject},
    datasource: {...datasourceObject}
  }
}